import Vue from 'vue'

Vue.component('v-btn', () => import('../components/@ui/button/button.vue'))
Vue.component('v-input', () => import('../components/@ui/input/input.vue'))
Vue.component('v-select', () => import('../components/@ui/select/select.vue'))
Vue.component('v-check', () => import('../components/@ui/checkbox/checkbox.vue'))
Vue.component('v-help', () => import('../components/helpBox/helpBox.vue'))
Vue.component('v-achievement', () => import('../components/achievementBox/achievementBox.vue'))
Vue.component('v-labels', () => import('../components/@layout/labels/labels'))
Vue.component('v-score', () => import('../components/@layout/Score/Score'))
Vue.component('v-hex', () => import('../components/@layout/hexagon/hexagon'))
Vue.component('v-draggable', () => import('../components/draggable/draggable'))
Vue.component('v-window', () => import('../components/@ui/window/window'))
Vue.component('v-comics', () => import('../components/comics/comics'))
